{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "forge",
  "worksWith": [
    {
      "type": "EXTENDS",
      "target": "intelligence",
      "label": "Extends"
    },
    {
      "type": "EXTENDS",
      "target": "vault",
      "label": "Extends"
    },
    {
      "type": "EXTENDS",
      "target": "operate",
      "label": "Extends"
    },
    {
      "type": "EXTENDS",
      "target": "shop",
      "label": "Extends"
    }
  ]
}